// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAZ0XYVVpJYzTn7FbQU8tLlGxRBwhzxulo",
    authDomain: "fairepart-a6a94.firebaseapp.com",
    databaseURL: "https://fairepart-a6a94.firebaseio.com",
    projectId: "fairepart-a6a94",
    storageBucket: "fairepart-a6a94.appspot.com",
    messagingSenderId: "937781510000"
  },
  root: ''
};



// WEBPACK FOOTER //
// /Users/mac-jeremy/Projets/fairepart/src/environments/environment.ts